import { computed } from 'vue';
import SCardsSmall from './cards-small.vue';
import * as mock from './mock.js';

export default {
    title: 'Slices/Pages/Cards Small',
    component: SCardsSmall,
    parameters: {
        design: {
            type: 'figma',
            url: mock.Figma,
        },
    },
};

export const Default = mock.Default;
export const TextOnly = mock.TextOnly;
export const Bullets = mock.Bullets;
export const Icon = mock.Icon;
export const Image = mock.Image;
export const Logo = mock.Logo;
export const Link = mock.Link;
export const PrimaryCta = mock.PrimaryCta;
export const CardLink = mock.CardLink;
export const Rate = mock.Rate;
export const Company = mock.Company;
export const Flip = { ...mock.Flip };

Flip.argTypes = {
    theme: {
        control: { type: 'inline-radio' },
        options: ['light', 'dark'],
    },
};

Flip.render = (args, context) => ({
    components: { SCardsSmall },
    setup() {
        const logoDark = '@7e46a307d5e33799bfaa104e5db43e08';
        const logoLight = '@8145c145b71a98fd4dfdd7102e453396';
        const theme = computed(() => args.theme || context.globals?.theme || 'light');
        const isDark = computed(() => theme.value === 'dark');
        const modifiedArgs = computed(() => {
            const nextCards = (args.cards || []).map((card) => ({
                ...card,
                front: {
                    ...card.front,
                    logo: isDark.value ? logoDark : (card.front?.logo || logoLight),
                },
            }));
            return { ...args, cards: nextCards };
        });
        return { modifiedArgs };
    },
    template: '<SCardsSmall v-bind="modifiedArgs" />',
});
